import { Component, Inject, OnInit } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EditorStyle, LabelMode } from 'devextreme/common';

@Component({
  selector: 'app-modal-formulario-editado',
  templateUrl: './modal-formulario-editado.component.html',
  styleUrls: ['./modal-formulario-editado.component.scss'],
})
export class ModalFormularioEditadoComponent implements OnInit {
  stylingMode: EditorStyle = 'outlined';
  labelMode: LabelMode = 'floating';

  constructor(
    public dialogRef: MatDialogRef<ModalFormularioEditadoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {},
  ) {}

  ngOnInit() {}

  onCancel() {
    this.dialogRef.close(false);
  }

  confirmarSalir() {
    this.dialogRef.close(true);
  }

  cancelarSalir() {
    this.dialogRef.close(false);
  }
}
